import { render, staticRenderFns } from "./dialogInform.vue?vue&type=template&id=3a1caba0&lang=pug"
import script from "./dialogInform.vue?vue&type=script&lang=js"
export * from "./dialogInform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports